/**
 * A name as the moderation screens say it: a moderator's marked so, in the
 * reader's language — "Ana (Moderator)", "Ana (Moderador)" — the name placed
 * by the language's own words. The match list's players, the voice monitor's
 * participants and its transcript's speakers each wrote the mark after the
 * name for themselves, in English order.
 */

import type { TFunction } from 'i18next';

/** A name as the moderation screens say it, marked when it is a moderator's. */
export function nameAsSaid(t: TFunction, name: string, moderator: boolean): string {
  return moderator ? t('players.moderatorNamed', { name }) : name;
}
